<div class="email-sent">
  <div class="background">
    <div class="email-icon">
      <app-svg-icon src="./assets/icons/ico_email.svg"> </app-svg-icon>
    </div>

    <div class="header">
      <h4>{{ 'module.public.emailSent.headerText' | translate }}</h4>
    </div>

    <div class="text">
      {{ 'module.public.emailSent.subHeaderText' | translate }}
    </div>
  </div>
</div>
